// removes minute mark, changes 4:00 PM -> 4PM
const formatTime = (time) => {
  const timeFormat = /^\d{1,2}:\d{2} (AM|PM)$/;
  if (timeFormat.test(time)) {
    const hourAndMinute = time.split(':');
    const hour = hourAndMinute[0];
    const minute = hourAndMinute[1].split(' ')[0];
    const period = hourAndMinute[1].split(' ')[1];
    if (minute === '00') {
      return `${hour}${period}`;
    }
  }
  return time;
};

export default formatTime;
